// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2671185e","727":"09c164cc"}[chunkId] + ".chunk.js";
};